export const convertUrl = (item) => {
	const isReactLink = item.url.includes("#/");
	const dustLinkParsed = item.url
		.replace("/index.html", "")
		.replace(".html", "");
	const dustLink = `#${dustLinkParsed}`;

	const url = isReactLink ? item.url : dustLink;
	return url;
};
